import VerticalChart from "./VerticalChart";

import * as React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Paper, Grid, FormControl, Select, MenuItem } from '@mui/material';
import { TextField } from "@mui/material";
import { PositionsState } from './ParamSettings';
import { useRecoilValue } from "recoil";

import shipImage from './ship.png'

var vc : VerticalChart[] = new Array(6);
for (let i=0; i<6; i++) {
  vc[i] = new VerticalChart();
}

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const FormRow = (index: number, v1: number, v2: number, v3: number) => {
  return (
    <React.Fragment>
      <Grid item xs={3}>
        {vc[index*3].get(v1)}
      </Grid>
      <Grid item xs={3}>
        {vc[index*3+1].get(v2)}
      </Grid>
      <Grid item xs={3}>
        {vc[index*3+2].get(v3)}
      </Grid>
      <Grid item xs={3} />
    </React.Fragment>
  );
};

const PosRow = () => {
  const positions = useRecoilValue(PositionsState);

  return (
    <Grid container spacing={9}>
      {positions.slice(0).reverse().map(pos1 => (
        <React.Fragment>
          <Grid container item xs={0.8} />
          <Grid container item xs={2}>
            <FormControl size="small" fullWidth>
              <Select defaultValue={pos1}>
                {positions.map(pos => (<MenuItem value={pos}>{pos}</MenuItem>))}
              </Select>
            </FormControl>
          </Grid>
        </React.Fragment>
      ))}
    </Grid>
  );
};

export default function ShipStrain() {
  return (
    <Box>
      <TextField size="small" type="number" id="outlined-basic" label="更新間隔[s]" variant="outlined" value={5} />
      <Box sx={{
        backgroundImage: `url(${shipImage})`,
        backgroundPosition: 'bottom',
        backgroundSize: '80% auto',
        backgroundRepeat: 'no-repeat',
        backgroundPositionX: '25%',
        p: 2
      }}>
        <Grid container spacing={9}>
          <Grid container item spacing={3} />
          <Grid container item spacing={3}>
            {FormRow(0, 600, 1000, 700)}
          </Grid>
          <Grid container item spacing={3}>
            {FormRow(1, 400, 600, 400)}
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ p: 2 }}>
        {PosRow()}
      </Box>
    </Box>
  );
}
